import { render, staticRenderFns } from "./OrganizationUsersComponent.vue?vue&type=template&id=5b2367eb&scoped=true&"
import script from "./OrganizationUsersComponent.vue?vue&type=script&lang=js&"
export * from "./OrganizationUsersComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationUsersComponent.vue?vue&type=style&index=0&id=5b2367eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2367eb",
  null
  
)

export default component.exports